<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Remove Payment Terminal</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      Are you sure you want to remove {{ reader.label }}? This action cannot be undone.
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-danger"
            (click)="handleRemove()"
            *ngIf="!loadingRemove">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingRemove">
      Loading...
    </button>
  </div>

</ng-container>
